<template>
  <form @submit.stop.prevent="createUser">
    <b-form-row>
      <b-col cols="12">
        <b-form-group>
          <label for="from_contact" v-translate>Name</label>
          <b-form-input id="from_contact" v-model="newUser.name" required />
        </b-form-group>
        <b-form-group>
          <label for="from_email" v-translate>E-mail</label>
          <b-form-input trim id="from_email" v-model="newUser.email" required />
          <b-form-text v-translate>An auto-generated password will be emailed to the new user.</b-form-text>
        </b-form-group>
        <b-form-group v-if="!userType">
          <label for="primary-role" v-translate>Primary Role</label>
          <b-form-select id="primary-role" v-model="primaryRole" :options="primaryRoleSelect" required>
            <template #first>
              <option :value="null" v-translate>-- Select an option --</option>
            </template>
          </b-form-select>
          <b-form-text v-translate>A primary role must be set for the new user.</b-form-text>
        </b-form-group>
      </b-col>
    </b-form-row>
    <b-alert variant="info" :show="existingUsers.length > 0">
      <h5 v-translate>Existing Users</h5>
      <p v-translate>There already are users with this e-mail. You may want to look at them (opens in new window):</p>
      <ul>
        <li v-for="(user, index) in existingUsers" :key="index">
          <b-link :to="{name: 'UsersEdit', params: { id: user.id }}" target="_blank">
            {{user.name}}
            (<span v-if="user.active" v-translate>enabled</span><span v-else>disabled</span>)
          </b-link>
        </li>
      </ul>
    </b-alert>
    <b-form-row>
      <b-col cols="12" class="text-center form-actions">
        <b-form-group>
          <b-button type="submit" variant="secondary">
            <span v-if="userType === null" v-translate>Create User</span>
            <span v-else v-translate="{roleName: userTypeComputed}">Create %{roleName}</span>
          </b-button>
          <b-button type="button" @click.prevent="emitCancel" variant="outline-secondary" v-translate>Cancel</b-button>
        </b-form-group>
      </b-col>
    </b-form-row>
  </form>
</template>

<script>
import {
  UserService
} from '@/services/api'

export default {
  emits: ['cancel', 'success'],
  name: 'UsersCreate',
  props: {
    userType: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      newUser: {},
      existingUsers: [],
      primaryRole: null,
      primaryRoleSelect: []
    }
  },
  computed: {
    userTypeComputed() {
      return this.$gettext(this.appRoles.find(x => x.value === this.primaryRole)?.text)
    }
  },
  watch: {
    primaryRole(val) {
      if (val) {
        this.newUser['x-moova-product'] = window.allowedRoles.find(x => x.role === this.appRoles.find(x => x.value === val).text).product
      }
    }
  },
  mounted () {
    this.primaryRole = this.appRoles.find(x => x.text === this.userType)?.value || null
    this.primaryRoleSelect = this.appRolesTranslated
  },
  methods: {
    createUser() {
      this.newUser.country_iso_code = this.profile.company.country_iso_code
      UserService.create(this.newUser)
        .then(response => {
          if (this.primaryRole) {
            UserService.addRole(response.body.id, [this.primaryRole])
              .then(() => {
                window.open('/users/edit/' + response.body.id + '?tab=0')
                this.emitSuccess()
              })
          } else {
            window.open('/users/edit/' + response.body.id)
            this.emitSuccess()
          }
        }, error => {
          if (error.status === 409) {
            this.$root.$children[0].$refs.simplert.justCloseSimplert()
            const params = {
              filter_groups: [{
                filters: [
                  ['email', 'eq', this.newUser.email]
                ]
              }]
            }
            UserService.getAll({ params })
              .then(response => {
                this.existingUsers = response.body.data
              })
          }
        })
    },
    emitSuccess() {
      this.$emit('success')
    },
    emitCancel() {
      this.$emit('cancel')
    }
  }
}
</script>
